module.exports = "<p>\n  <img src=\"assets/elzeviro3.png\">\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main